import React, { useEffect, useState } from "react";
import { RaceDTO } from "../../../interfaces/RaceDTO";
import ResultRow from "./ResultRow";
import { AthleteDTO } from "../../../interfaces/AthletesDTO";
import ResultTableHeader from "./ResultTableHeader";
import { ViewType } from "../../../interfaces/internal/ViewProps";
import { TimingPositionsDTO } from "../../../interfaces/TimingPositionsDTO";
import { eventBus } from "../../../services/eventHandler";
import { ResultTableProvider } from "../../../services/ResultTableProvider";
import { useBlade } from "../../../services/BladeProvider";

interface Props {
  race: RaceDTO;
  classid: number | null;
  level: number | null;
  Tpos: TimingPositionsDTO | null;
  vType: ViewType;
  Ipos?: number | null;
  vwindPropId: number;
}
interface TimePoses {
  ipos: number;
  aftershootnr: number;
  leg: number;
}

const ResultTable = ({ race, classid, level, Tpos, vType, Ipos,vwindPropId }: Props) => {
  const [athletes, setAthletes] = useState<AthleteDTO[]>([]);
  const [timePos, setTimePos] = useState<TimePoses | null>(null);
  const {getMaximizeBlade} = useBlade();

  useEffect(() => {
    
    
  },[getMaximizeBlade(vwindPropId)]);

  useEffect(() => {
    const handlerAddAthlete = (ath: AthleteDTO) => {
      if (ath.ClassID === classid && ath.Level === level) {
        setAthletes((prev) => [...prev, ath]);
      }
    };
    eventBus.on(`athlete_add`, handlerAddAthlete);
    return () => {
      // Cleanup to avoid memory leaks
      eventBus.removeListener(`athlete_add`, handlerAddAthlete);
    };
  }, []);

  useEffect(() => {
    const levelData = race?.Class?.[classid!]?.Level?.[level!];
    if (levelData) {
      const athletesArr = Object.values(levelData.Athletes).flat();
      setAthletes(athletesArr);
    }
  }, [race, classid, level]);

  useEffect(() => {
    let tvpos: TimePoses | null = null;

    if (Ipos !== null && Ipos !== undefined) {
      tvpos = {
        ipos: Ipos,
        aftershootnr: 0,
        leg: 0,
      };
    } else if (Tpos) {
      tvpos = {
        ipos: Tpos.Ipos || 0,
        aftershootnr: Tpos.AfterShootNr || 0,
        leg: Tpos.Leg || 0,
      };
    } else {
    }

    if (tvpos) {
      setTimePos(tvpos);
    }
  }, [Tpos, Ipos]); // Added Ipos in the dependency array since it's being used inside the effect.

  return (
    <>
      <ResultTableProvider>
        {timePos == null ? (
          <ResultTableHeader ipos={Ipos} afterShootnr={0} />
        ) : (
          <ResultTableHeader ipos={Ipos} afterShootnr={timePos.aftershootnr} />
        )}

        <div className="result-blade-rows">
          {timePos === null
            ? null
            : athletes.map((at) => {
                const isStageView = vType === ViewType.stage;
                return (
                  <ResultRow
                    key={at.ID}
                    afterShootnr={timePos.aftershootnr}
                    athlete={at}
                    ipos={isStageView ? -999 : timePos.ipos}
                    vType={vType}
                    race={race}
                    leg={isStageView ? 0 : timePos.leg}
                  />
                );
              })}
        </div>
      </ResultTableProvider>
    </>
  );
};
export default ResultTable;
